<template>
  <footer id="BGCard" class="p-4 rounded-lg shadow md:px-6 md:py-8 dark:bg-gray-800">
    <div class="flex items-center justify-between">
      <a href="#" class="flex items-center mb-4 sm:mb-0">
              <span class="text-xl font-semibold dark:text-gray-100">
                <svg id="Brand" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                </svg>
              </span>
        <span class="mx-1 self-center text-2xl font-semibold whitespace-nowrap dark:text-indigo-500">{ <span class="text-white">RG</span> }</span>
      </a>
      <ul class="flex flex-wrap items-center mb-6 text-sm sm:mb-0 dark:text-gray-400">
        <li>
          <div class="mt-1.5">
            <button onclick="goto('https://mail.google.com/mail/u/0/?fs=1&to=wsengineerrg@gmail.com&su=SUBJECT&body=Ton%20Message&tf=cm')" class="cursor-link hover:cursor-pointer">
              <img class="flex justify-center w-6 h-6 mr-2 -ml-1 hover:cursor-pointer" src="https://img.icons8.com/color/48/000000/gmail-new.png" alt=""/>
            </button>
          </div>
        </li>
        <li>
          <div class="mx-2 mt-1.5">
            <button onclick="goto('https://www.linkedin.com/in/romain-gaspari-423a06230/')" class="cursor-link hover:cursor-pointer">
              <img class="flex justify-center w-6 h-6 mr-2 -ml-1 hover:cursor-pointer" src="../assets/Linkedin_perspective_matte.png"/>
            </button>
          </div>
        </li>
      </ul>
    </div>
    <hr class="my-6 sm:mx-auto dark:border-gray-700 lg:my-8">
    <span class="block text-sm sm:text-center dark:text-gray-400">© 2022 <a class="hover:underline">RG™</a>. All Rights Reserved.</span>
  </footer>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Footer"
}
</script>

<style scoped>

</style>